<!-- <app-navbar></app-navbar> -->
<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<div class="h-100">
    <router-outlet></router-outlet>
</div>
